
import { Box, styled, Typography, Link } from '@mui/material';
import { GitHub, Instagram, Email } from '@mui/icons-material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const Banner = styled(Box)`
    background-image: url(https://www.wallpapertip.com/wmimgs/23-236943_us-wallpaper-for-website.jpg);
    width: 100%;
    height: 50vh;
    background-position: left 0px bottom 0px;
    background-size: cover;
`;

const Wrapper = styled(Box)`
    padding: 20px;
    & > h3, & > h5 {
        margin-top: 50px;
    }
`;

const Text = styled(Typography)`
    color: #878787;
`;
 const iconStyle = {
    marginLeft: 2,
    fontSize: '29px',
    transition: 'transform 0.3s ease-in-out',
  };
const About = () => {

    return (
        <Box>
            <Banner/>
            <Wrapper>
                <Typography variant="h3">Mayank Johari</Typography>
                <Text variant="h5">I'm a Software Engineer based in India. 
                    I am Competitive Programmer.<br />
                    If you are interested, You can view my Github from here
                    <Box component="span" style={{ marginLeft: 5 }}>
                        <Link href="https://github.com/mayankmj" color="inherit" target="_blank"><GitHub /></Link>
                    </Box>
                    <br />
                    You can view some of my favorite projects here Portfolio 
                    <Box component="span" style={{marginLeft:5}}>
                        <Link href="https://portfolio-mayankmj.vercel.app/" style={iconStyle} color="inherit" target="_blank"><ArrowRightAltIcon /></Link>
                    </Box>
                    
                </Text>
                <Text variant="h5">
                    Need something built or simply want to have chat? Reach out to me on
                    <Box component="span" style={{ marginLeft: 5 }}>
                        <Link href="https://www.instagram.com/assassin__mayank/" color="inherit" target="_blank">
                            <Instagram />
                        </Link>
                    </Box>  
                        or send me an Email 
                        <Link href="mailto:mayankjohari877@gmail.com?Subject=This is a subject" target="_blank" color="inherit">
                            <Email />
                        </Link>.
                </Text>
            </Wrapper>
        </Box>
    )
}

export default About;